import { Flex, Text } from '@chakra-ui/react';
import { ButtonText } from '@morressier/alembic';
import { IActivityLog, ISubmissionFile } from '@publishing-engine/domain/models';
import _ from 'lodash';
import { useState } from 'react';
import { IGetSubmissionUnsubmitResponse } from '@publishing-engine/submission-service/src/endpoints/api.response-types';
import { UnsubmitContextModal } from '../modals/UnsubmitContextModal.js';

export const SubmissionUnsubmitted: React.FC<{
  changes?: IActivityLog['changes'];
}> = ({ changes }) => {
  const [show, setShow] = useState(false);
  const { submission } = changes?.reduce((acc, change) => {
    const [k, v] = Object.entries(change)[0] ?? ['', ''];
    return _.set(acc, k, v);
  }, {}) as {
    submission: {
      editorComment: string;
      attachments: ISubmissionFile[];
    };
  };

  const onClose = () => setShow(false);

  return (
    <Flex
      flexDirection={'column'}
      width={'100%'}
      alignItems={'flex-start'}
      gap={2}
    >
      <Text noOfLines={3}>{submission.editorComment}</Text>
      <ButtonText onClick={() => setShow(true)}>View Full Details</ButtonText>

      {show && (
        <UnsubmitContextModal
          data={submission as IGetSubmissionUnsubmitResponse}
          onClose={onClose}
        />
      )}
    </Flex>
  );
};
